<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h3 class="panel-title text-center">Which letter completes this word? <strong>{{ displayWord }}</strong></h3>
    </div>
    <div class="panel-body">
      <div
        v-for="(btn, index) in btnData"
        :key="index"
        class="col-xs-12 col-md-12 col-sm-12 text-center"
      >
        <button
          class="btn btn-primary btn-lg"
          style="margin: 10px; min-width: 80px;"
          :disabled="revealed"
          @click="onAnswer(btn.correct, btn.letter)"
        >
          {{ btn.letter }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
var randomWords = require("random-words");

export default {
  data() {
    return {
      word: "",
      hiddenIndex: 0,
      revealed: false,
      revealedLetter: "",
      btnData: [
        { correct: true, letter: "" },
        { correct: false, letter: "" },
        { correct: false, letter: "" },
        { correct: false, letter: "" },
      ],
    };
  },
  computed: {
    maskedWord() {
      if (!this.word) return "";
      return this.word
        .split("")
        .map((char, i) => (i === this.hiddenIndex ? "_" : char))
        .join("");
    },
    displayWord() {
      if (!this.word) return "";
      return this.word
        .split("")
        .map((char, i) => {
          if (i === this.hiddenIndex) {
            return this.revealed ? this.revealedLetter : "_";
          }
          return char;
        })
        .join("");
    },
  },
  methods: {
    generateQuestion() {
      // Get a random word (at least 3 characters so the masked version is interesting)
      let newWord = "";
      do {
        newWord = randomWords();
      } while (newWord.length < 3);

      this.word = newWord;

      // Pick a random index to hide
      this.hiddenIndex = Math.floor(Math.random() * newWord.length);
      const correctLetter = newWord[this.hiddenIndex];

      // Build 3 unique wrong letters from the alphabet
      const alphabet = "abcdefghijklmnopqrstuvwxyz";
      const wrongLetters = [];
      while (wrongLetters.length < 3) {
        const candidate = alphabet[Math.floor(Math.random() * alphabet.length)];
        if (candidate !== correctLetter && !wrongLetters.includes(candidate)) {
          wrongLetters.push(candidate);
        }
      }

      // Assign all four options and shuffle
      const options = [
        { correct: true, letter: correctLetter },
        { correct: false, letter: wrongLetters[0] },
        { correct: false, letter: wrongLetters[1] },
        { correct: false, letter: wrongLetters[2] },
      ];

      // Fisher-Yates shuffle
      for (let i = options.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [options[i], options[j]] = [options[j], options[i]];
      }

      this.btnData = options;
    },
    onAnswer(isCorrect, letter) {
      if (isCorrect) {
        this.revealedLetter = letter;
        this.revealed = true;
        setTimeout(() => {
          this.$emit("answered", true);
        }, 800);
      } else {
        this.$emit("answered", false);
      }
    },
  },
  created() {
    this.generateQuestion();
  },
};
</script>
